__turbopack_context__.v({
  "longTitle": "po8Feq_longTitle",
  "regularTitle": "po8Feq_regularTitle",
  "title": "po8Feq_title",
  "veryLongTitle": "po8Feq_veryLongTitle",
});
